import {createContext} from "preact";
import {useContext, useEffect, useState} from "preact/hooks";
import PublicService from "../services/PublicService";

const CustomerContext = createContext({
    customer: {},
    isLoading: true,
    error: undefined,
    isMember: () => Boolean,
});

export function CustomerProvider({ customerEmail, customerId, children }) {
    const [isLoading, setIsLoading] = useState(true);
    const [customer, setCustomer] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        if (customerId) {
            setIsLoading(true);
            PublicService.fetchCustomer(customerId, customerEmail)
                .then(res => res.json())
                .then(({ data }) => setCustomer(data))
                .catch(err => console.error(err) && setError(err))
                .finally(() => setIsLoading(false));
        }

    }, []);

    const isMember = () => {
        return false;
    }

    return (
        <CustomerContext.Provider value={{
            customer,
            setCustomer,
            error,
            setError,
            isLoading,
            setIsLoading,
            isMember,
        }}>
            {children}
        </CustomerContext.Provider>
    )
}

export function useCustomerContext() {
    return useContext(CustomerContext);
}

export default CustomerContext;
